import React from "react";

const AuditWidget = ({ value }) => {
  return value ? (
    <div className={`flex flex-col gap-1 text-gray-600 text-[14px]`}>
      <div className="flex gap-3">
        <div className="flex items-center gap-1">
          <span className="font-medium">Create User :</span>
          <span className="">{value.createUserName}</span>
        </div>
        <div className="flex items-center gap-1">
          <span className="font-medium">Created At :</span>
          <span className="">{value.createdAt}</span>
        </div>
      </div>

      {value.lastUpdateUserName && (
        <div className="flex gap-3">
          <div className="flex items-center gap-1">
            <span className="font-medium">Updated User :</span>
            <span className="">{value.lastUpdateUserName}</span>
          </div>
          <div className="flex items-center gap-1">
            <span className="font-medium">Updated At :</span>
            <span className="">{value.updateAt}</span>
          </div>
        </div>
      )}
    </div>
  ) : (
    "-"
  );
};

export default AuditWidget;
